import React from "react";
import { PongSpinner } from "react-spinners-kit";

export function TopLevelSpinner() {
	return <PongSpinner color={"white"} />;
}
